import React from 'react';
import { Stack } from 'react-bootstrap';
import ClientDashboardScatter from './client-dashboard-scatter';
import ClientDashboardAssessmentStatus from './client-dashboard-assessment-status';
import ClientDashboardLeadershipDonuts from './client-dashboard-leadership-donuts';
const ClientDashboardLeadershipCharts = ({
  aggregations,
  assessmentsSummary,
  candidates,
  ratersAssessmentsSummary,
}) => {
  return (
    <>
      <Stack className="pb-3 pb-3 d-none d-md-flex" gap={3}>
        <Stack direction="horizontal" gap={3}>
          <div className="chart-card flex-grow-1 w-50 h-100">
            <ClientDashboardScatter candidates={candidates} aggregations={aggregations} />
          </div>
          <div className="chart-card d-flex flex-column flex-grow-1 w-50 h-100">
            <ClientDashboardLeadershipDonuts aggregations={aggregations} />
          </div>
        </Stack>
        <Stack direction="horizontal" gap={3}>
          <Stack className="chart-card w-50 m-auto">
            <ClientDashboardAssessmentStatus assessmentsSummary={assessmentsSummary} />
          </Stack>
          <Stack className="chart-card w-50 m-auto">
            <ClientDashboardAssessmentStatus assessmentsSummary={ratersAssessmentsSummary} raters={true} />
          </Stack>
        </Stack>
      </Stack>
      <Stack direction="vertical" className="pb-3 pb-3 d-md-none" gap={3}>
        <div className="chart-card flex-grow-1 w-100 h-100">
          <ClientDashboardLeadershipDonuts aggregations={aggregations} />
        </div>
        <div className="chart-card flex-grow-1 w-100 h-100">
          <ClientDashboardScatter candidates={candidates} aggregations={aggregations} />
        </div>
        <div className="chart-card flex-grow-1 w-100 h-100">
          <ClientDashboardAssessmentStatus assessmentsSummary={assessmentsSummary} />
        </div>
        <div className="chart-card flex-grow-1 w-100 h-100">
          <ClientDashboardAssessmentStatus assessmentsSummary={ratersAssessmentsSummary} raters={true} />
        </div>
      </Stack>
    </>
  );
};

export default ClientDashboardLeadershipCharts;
